import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import HomeApi from "../../api/home.api";
import MainLayout from "../../component/atoms/layout/mainLayout";
import PretendardText from "../../component/atoms/text/pretendardText";
import MainGraph from "../../component/molecules/mainGraph";
import Header from "../../component/organisms/header";
import Sidebar from "../../component/organisms/sidebar";
import { route } from "../../router/route";
import { errorHandler } from "../../util/errorHandler";

function Home(props) {
  const navigate = useNavigate();

  // ----------------------------------------------------------------------- //
  // ------------------------------- 메뉴 ------------------------------- //
  // --------------------------------------------------------------------- //
  const quickMenu = [
    {
      category: "사용자 관리",
      title: "회원 관리",
      route: route.user_common_member,
      permissionRoute: route.user_common_member,
    },
    {
      category: "강의 관리",
      title: "금융 스터디 관리",
      route: route.lecture_category_finance,
      permissionRoute: route.lecture_category_finance,
    },
    {
      category: "강의 관리",
      title: "유료 강의 관리",
      route: route.lecture_category_paid,
      permissionRoute: route.lecture_category_finance,
    },
    {
      category: "커뮤니티 관리",
      title: "게시글 관리",
      route: route.community_post,
      permissionRoute: route.community_post,
    },
    {
      category: "커뮤니티 관리",
      title: "신고 관리",
      route: route.community_report_post,
      permissionRoute: route.community_report_post,
    },
    {
      category: "서비스 관리",
      title: "메인 배너 관리",
      route: route.service_banner_main,
      permissionRoute: route.service_banner_main,
    },
  ];

  const accessMenu = sessionStorage.getItem("accessMenu");
  const visibleQuickMenu = quickMenu.filter(
    (item) =>
      sessionStorage.getItem("role") === "ROOT" ||
      accessMenu?.includes(item.permissionRoute)
  );

  // -------------------------------------------------------------------- //
  // ------------------------------- 상태 ------------------------------- //
  // ------------------------------------------------------------------- //
  //방문자수, 날짜 정보
  const [totalVisitor, setTotalVisitor] = useState([]);
  const [graphMax, setGraphMax] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(null);
  const [totalMemberCount, setTotalMemberCount] = useState({
    activationCount: 0,
    totalCount: 0,
    retiredCount: 0,
  });
  const [visitLine, setVisitLine] = useState([]);

  // ---------------------------------------------------------------------- //
  // ------------------------------- 마운트 ------------------------------- //
  // --------------------------------------------------------------------- //

  // 로그인 안 되어있으면 로그인 페이지로 리다이렉션
  useEffect(() => {
    getMemberCount(); // 회원수 가져오기
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // 방문자수 페이지 넘길 때마다 가져오기
  useEffect(() => {
    getVisitorCount();
  }, [currentPage]); // eslint-disable-line react-hooks/exhaustive-deps

  // 회원수 가져오기
  const getMemberCount = async () => {
    try {
      const response = (await HomeApi.getMemberCount()).data.data;
      setTotalMemberCount(response);
    } catch (error) {
      errorHandler(error);
    }
  };

  // 방문자수 가져오기
  const getVisitorCount = async () => {
    try {
      const data = {
        page: currentPage,
        size: 10,
      };
      const response = (await HomeApi.getVisitorCount(data)).data.data;

      setTotalVisitor(response.content);
      //totalPage 구하기
      setTotalPages(Math.ceil(response.totalCount / 10));
    } catch (error) {
      errorHandler(error);
    }
  };

  // ---------------------------------------------------------------------- //
  // ------------------------------- 그래프 ------------------------------- //
  // --------------------------------------------------------------------- //

  useEffect(() => {
    let line = [];
    let max = 0;
    for (let i = 0; i < totalVisitor.length; i++) {
      if (max <= totalVisitor[i].count) {
        max = totalVisitor[i].count;
      }
    }
    setGraphMax(max);
    let per = max / 3;
    for (let i = 0; i < 3; i++) {
      line.push(Math.round(max - per * i));
    }
    setVisitLine(line);
  }, [totalVisitor]);

  return (
    <>
      <Header />
      <MainLayout>
        <Sidebar />
        <HomeWrapper>
          <HomeHeader>
            <div
              style={{
                width: "100%",
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
              }}
            >
              <PretendardText
                style={{
                  color: "#808991",
                  fontSize: "20px",
                  fontWeight: "600",
                  lineHeight: "34px",
                  letterSpacing: "-0.06px",
                }}
              >
                Welcome!
              </PretendardText>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <PretendardText
                  style={{
                    color: "#262C31",
                    fontSize: "40px",
                    fontWeight: "700",
                    lineHeight: "56px",
                    letterSpacing: "-0.28px",
                  }}
                >
                  안녕하세요. 관리자님 :)
                </PretendardText>
                <TotalCountWrapper>
                  {/* 전체 사용자 수 */}
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: 14,
                    }}
                  >
                    <PretendardText
                      style={{
                        fontWeight: 700,
                        fontSize: 16,
                        lineHeight: "28px",
                        letterSpacing: "-0.3%",
                        color: "#636c73",
                      }}
                    >
                      전체 사용자 수
                    </PretendardText>
                    <TextDivider />
                    <PretendardText
                      style={{
                        fontWeight: 700,
                        fontSize: 16,
                        lineHeight: "28px",
                        letterSpacing: "-0.3%",
                        color: "#636c73",
                      }}
                    >
                      {totalMemberCount?.activationCount}명
                    </PretendardText>
                  </div>

                  {/* 회원(가입/탈퇴) */}
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: 14,
                    }}
                  >
                    <PretendardText
                      style={{
                        fontWeight: 700,
                        fontSize: 16,
                        lineHeight: "28px",
                        letterSpacing: "-0.3%",
                        color: "#636c73",
                      }}
                    >
                      회원(가입/탈퇴)
                    </PretendardText>
                    <TextDivider />
                    <PretendardText
                      style={{
                        fontWeight: 700,
                        fontSize: 16,
                        lineHeight: "28px",
                        letterSpacing: "-0.3%",
                        color: "#636c73",
                      }}
                    >
                      {totalMemberCount?.totalCount}/
                      {totalMemberCount?.retiredCount}
                    </PretendardText>
                  </div>
                </TotalCountWrapper>
              </div>
            </div>
          </HomeHeader>
          <HomePretendardText style={{ marginBottom: "10px" }}>
            방문자 통계
          </HomePretendardText>
          <MainGraph
            visit={totalVisitor}
            graphMax={graphMax}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            totalPages={totalPages}
            visitLine={visitLine}
          />
          <HomePretendardText style={{ marginBottom: "10px" }}>
            퀵메뉴
          </HomePretendardText>
          <QuickMenuWrapper>
            {visibleQuickMenu.map((item, index) => {
              return (
                <QuickMenu
                  onClick={() => navigate(`${item.route}?page=1`)}
                  key={index}
                >
                  <QuickMenuCaption>{item.category}</QuickMenuCaption>
                  <QuickMenuTitle>{item.title}</QuickMenuTitle>
                </QuickMenu>
              );
            })}
          </QuickMenuWrapper>
        </HomeWrapper>
      </MainLayout>
    </>
  );
}

export default Home;

const HomeWrapper = styled.div.attrs((props) => {})`
  width: 1044px;
  height: auto;
  margin-top: 190px;
`;

const HomeHeader = styled.div.attrs((props) => {})`
  width: 1044px;
  height: 90px;
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  margin-bottom: 40px;
`;

const TotalCountWrapper = styled.div.attrs((props) => {})`
  padding: 14px 40px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 50px;
  background: #f2f4f5;
  border-radius: 6px;
`;

const HomePretendardText = styled(PretendardText).attrs((props) => {})`
  color: #262c31;
  font-size: 16px;
  font-weight: 700;
  line-height: 28px; /* 175% */
  letter-spacing: -0.048px;
`;

const QuickMenuWrapper = styled.div.attrs((props) => {})`
  width: 1044px;
  display: flex;
  align-items: center;
  gap: 10px 21px;
  flex-wrap: wrap;
  margin-bottom: 103px;
`;

const QuickMenu = styled.div.attrs((props) => {})`
  width: 334px;
  height: 113px;
  border-radius: 8px;
  border: 1px solid var(--gray-2, #d7dbe0);
  padding: 27px 32px;
  cursor: pointer;
`;

const QuickMenuCaption = styled(PretendardText).attrs((props) => {})`
  color: #27beff;
  font-size: 14px;
  font-weight: 600;
  line-height: 22.75px; /* 163.333% */
  margin-bottom: 4px;
`;

const QuickMenuTitle = styled(PretendardText).attrs((props) => {})`
  color: #333;
  font-size: 18px;
  font-weight: 700;
  line-height: 25px; /* 170% */
  letter-spacing: -0.054px;
  cursor: pointer;

  &::after {
    content: url("/assets/admin/icons/ico_quick_arrow.svg");
    margin-left: 6px;
    width: 20px;
    height: 20px;
    position: relative;
    top: 4px;
  }
`;

const TextDivider = styled.span`
  height: 10px;
  width: 1px;
  background-color: #b8bfc4;
`;
